import { ServiceResponse } from '@sdbn/common';
import { PageCall } from '@sdbn/tmc-common';

export class TerminalTruckRegistration extends ServiceResponse {

    terminalIdentifier: string;
    carrier: string;
    coDriver: string;
    driver: string;
    supplier: string;
    numberPlate: string;
    gcCaseId: string;
    gcCaseUrl: string;
    messagingLanguage: string;
    pageCalls = new Array<PageCall>();
    registrationId: number;
    registrationFinished: number;
    registrationStarted: number;
    smartphoneCommunicationEnabled: boolean;
    smartphoneConnected: boolean;
    smartphoneRequired: boolean;
    useGlobalConnect: boolean;

    constructor(details?: Partial<TerminalTruckRegistration>) {
        super(details);
        if (details != null) {
            this.terminalIdentifier = details.terminalIdentifier;
            this.carrier = details.carrier;
            this.coDriver = details.coDriver;
            this.driver = details.driver;
            this.supplier = details.supplier;
            this.numberPlate = details.numberPlate;
            this.gcCaseId = details.gcCaseId;
            this.gcCaseUrl = details.gcCaseUrl;
            this.messagingLanguage = details.messagingLanguage;
            if (details.pageCalls) {
                for (const pageCall of details.pageCalls) {
                    this.pageCalls.push(new PageCall(pageCall));
                }
            }
            this.useGlobalConnect = details.useGlobalConnect;
            this.registrationId = details.registrationId;
            this.registrationFinished = details.registrationFinished;
            this.registrationStarted = details.registrationStarted;
            this.smartphoneCommunicationEnabled = details.smartphoneCommunicationEnabled;
            this.smartphoneConnected = details.smartphoneConnected;
            this.smartphoneRequired = details.smartphoneRequired;
        }
    }
}

export class TerminalTruckRegistrationResult extends ServiceResponse {

    numberPlate: string;
    trailerNumberPlate: string;
    registrationId: number;
    driver: string;
    coDriver: string;
    carrier: string;
    supplier: string;
    gatekeeperMandatory: boolean;

    constructor(details?: Partial<TerminalTruckRegistrationResult>) {
        super(details);
        if (details != null) {
            this.carrier = details.carrier;
            this.coDriver = details.coDriver;
            this.driver = details.driver;
            this.supplier = details.supplier;
            this.numberPlate = details.numberPlate;
            this.trailerNumberPlate = details.trailerNumberPlate;
            this.registrationId = details.registrationId;
            this.gatekeeperMandatory = details.gatekeeperMandatory;
        }
    }
}
